import PricingForm from "../forms/pricingForm";

// Definiujemy, jakich danych oczekuje nasz komponent Hero
interface SinglePostHeroProps {
  title: string;
  date: string;
  imageUrl?: string;
}

function SinglePostHero({ title, date, imageUrl }: SinglePostHeroProps) {
 
  const bgImage = imageUrl || "https://magazyn.drzewus.pl/wp-content/uploads/2024/10/contactimg.jpeg";

  return (
    <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36">
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src={bgImage}
        alt={title}
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
      
      <div className="flex flex-col items-start justify-center gap-2 z-30 mb-6 lg:mb-0 max-w-2xl">
        <h2 className="text-white font-semibold text-sm uppercase tracking-wide">
          Poradnik Drzewus
        </h2>
        
        <h1 className="text-3xl lg:text-5xl text-white font-bold leading-tight mb-2 text-start">
          {title}
        </h1>
        

        <p className="text-white text-base lg:text-lg opacity-90 text-start">
          Opublikowano: {date}
        </p>
      </div>

      <div className="z-30 max-w-[500px] flex flex-col items-center justify-center w-full mt-10 lg:mt-0">
        <PricingForm />
      </div>
    </section>
  );
}

export default SinglePostHero;